<template>
    <journey-connection-property-base :label="resource('JourneyBuilder_DeduplicationSettings_FieldName')" :for-input="id">
        <v-select class="form-control"

                  :id="id"
                  v-model="model"

                  :options="options"
                  :disabled="!canWrite || !isActive"

                  searchable
                  filterable
        >
            <div slot="no-options" />
        </v-select>
    </journey-connection-property-base>
</template>

<script>
    import resources from '../../../../../../Util/Mixins/resources';
    import permissionsMixin from '../../../../Mixins/journey-permissions';
    
    import VSelect from 'vue-select';
    import JourneyConnectionPropertyBase from './../JourneyConnectionPropertyBase.vue';
    
    export default {
        name: 'journey-connection-deduplication-field',
        mixins: [resources, permissionsMixin],
        components: {
            VSelect,
            JourneyConnectionPropertyBase
        },
        data: () => ({
            id: 'DeduplicationField'
        }),
        computed: {
            model: {
                get(){
                    const vm = this;
                    return vm.options.find(({name}) => name === vm.value);
                },
                set(value){
                    this.$emit('input', value ? value.name : null);
                }
            }
        },
        props: {
            value: {
                type: String
            },
            isActive: {
                type: Boolean,
                required: true
            },
            options: {
                type: Array,
                required: true
            }
        }
    }
</script>